import moment from "moment";

export const handleDateFormating = (date) => {
   return moment(date).format("MMM Do YYYY");
};
